import script from "./ProductDeliveryTemplateSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDeliveryTemplateSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductDeliveryTemplateSkeleton.vue?vue&type=style&index=0&id=bab8a102&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab8a102"]])

export default __exports__